@let job = batchJobSchedule();
<form [formGroup]="form" class="flex flex-col overflow-hidden h-full">
  <div class="flex-1 flex flex-col h-full overflow-hidden">
    <p-scroll-panel class="flex-1 flex overflow-hidden">
      <h3>Status</h3>
      <table class="detail-table">
        <tr>
          <td class="detail-label">Jobnavn</td>
          <td>
            @if (allowEdit()) {
              <input
                pInputText
                autofocus
                formControlName="jobNavn"
                class="w-[300px]" />
              @if (
                form.controls['jobNavn'].errors &&
                form.controls['jobNavn'].touched
              ) {
                <p class="text-error">Feltet skal udfyldes</p>
              }
            } @else {
              {{ job?.jobNavn }}
            }
          </td>
        </tr>
        <tr>
          <td class="detail-label">Jobtype</td>
          <td>
            @if (allowEdit()) {
              <p-select
                [options]="batchJobTypes.value()?.data"
                class="w-[300px]"
                formControlName="batchJobTypeId"
                optionLabel="navn"
                optionValue="id"
                [showClear]="true"
                appendTo="body"
                (onChange)="onChangeBatchJobType($event)" />
              @if (
                form.controls['batchJobTypeId'].errors &&
                form.controls['batchJobTypeId'].touched
              ) {
                <p class="text-error">Feltet skal udfyldes</p>
              }
            } @else {
              {{ job?.batchJobType?.navn }}
            }
          </td>
        </tr>
        <tr>
          <td class="detail-label">Skal startes efter</td>
          <td>
            @if (allowEdit()) {
              <p-select
                [options]="koeresEfterOptions()"
                class="w-[300px]"
                formControlName="udfoeresEfter"
                optionLabel="jobNavn"
                optionValue="id"
                [showClear]="true"
                appendTo="body" />
            } @else {
              {{ job?.udfoeresEfter }}
            }
          </td>
        </tr>
        @if (!form.value.udfoeresEfter) {
          <tr>
            <td class="detail-label">Frekvens</td>
            <td>
              @if (allowEdit()) {
                <p-select
                  [options]="frekvensOptions"
                  class="w-[300px]"
                  formControlName="frekvens"
                  optionLabel="text"
                  optionValue="value"
                  [showClear]="true"
                  appendTo="body" />
              } @else {
                {{ job?.frekvens }}
              }
            </td>
          </tr>
          <tr>
            <td class="detail-label">Kørselstidpunkt</td>
            <td>
              @if (allowEdit()) {
                <app-let-date-picker
                  formControlName="koerselsTidspunkt"
                  [showTime]="true" />
              } @else {
                {{ job?.koerselsTidspunkt | date: 'dd-MM-yyyy HH:mm' }}
              }
            </td>
          </tr>
        }
      </table>

      @if (allowEdit()) {
        @if (availableParameters().length > 0) {
          <div formGroupName="parameters">
            <h3>Job parametre</h3>
            <table class="detail-table">
              @for (p of availableParameters(); track $index) {
                <tr>
                  <td>
                    <p-checkbox
                      [binary]="true"
                      [formControlName]="p.parameterNavn + '_Checked'"
                      [readonly]="p.paakraevet" />
                  </td>
                  <td class="detail-label" style="height: 41px">
                    {{ p.parameterNavn }}
                  </td>
                  <td>
                    @if (p.parameterType === 'Boolean') {
                      <div class="flex gap-4">
                        <div class="flex items-center">
                          <p-radiobutton
                            [name]="p.parameterNavn"
                            value="True"
                            [formControlName]="p.parameterNavn" />
                          <label class="ml-2">Ja</label>
                        </div>
                        <div class="flex items-center">
                          <p-radiobutton
                            [name]="p.parameterNavn"
                            value="False"
                            [formControlName]="p.parameterNavn" />
                          <label class="ml-2">Nej</label>
                        </div>
                      </div>
                    } @else if (p.parameterType === 'Number') {
                      <p-input-number
                        [formControlName]="p.parameterNavn"></p-input-number>
                    } @else {
                      @if (p.parameterNavn === 'ItCentral') {
                        <p-select
                          [options]="['BD', 'BEC', 'SDC']"
                          class="w-[100px]"
                          [formControlName]="p.parameterNavn"
                          [showClear]="true"
                          appendTo="body" />
                      } @else {
                        <input
                          pInputText
                          class="w-[600px]"
                          [formControlName]="p.parameterNavn" />
                      }
                    }
                    @if (
                      form.controls[p.parameterNavn] &&
                      form.controls[p.parameterNavn].errors &&
                      form.controls[p.parameterNavn].touched
                    ) {
                      <p class="text-error">Feltet skal udfyldes</p>
                    }
                  </td>
                </tr>
              }
            </table>
          </div>
        }
      } @else {
        @if (parameterValues.isLoading()) {
          <p-skeleton class="mb-2" />
          <p-skeleton class="mb-2" />
        }
        <table class="detail-table bordered">
          @let params = parameterValues.value()?.data;
          @if (params) {
            @for (p of params; track p.id) {
              <tr>
                <td class="detail-label">{{ p.parameterNavn }}</td>
                <td>{{ p.parameterVaerdi }}</td>
              </tr>
            }
          }
        </table>
      }
    </p-scroll-panel>
    @if (allowEdit()) {
      <div class="mt-4">
        <div class="flex justify-end gap-4">
          <p-button label="OK" (click)="onClickOk()" type="submit" />
          <p-button label="Annuller" outlined (click)="onClickCancel()" />
        </div>
      </div>
    }
  </div>
</form>
